import * as React from "react";
import { Typography } from "@mui/material";
import { platformSectionTitleSx } from "../tickitPlatformTheme";

/** HTML `.card-title` used as section heading */
export default function PlatformSectionTitle({ children, sx = {} }) {
  return (
    <Typography component="h2" sx={{ ...platformSectionTitleSx, mb: 1.75, ...sx }}>
      {children}
    </Typography>
  );
}
